// extracted by mini-css-extract-plugin
module.exports = {"shareContent":"shareContent"};